import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import LocationSearch from '../hero/hero-rslhome/FromTo'
import Location from '../hero/hero-rslhome/AddressBookRideActivities'
import TextField from '@mui/material/TextField'
import CarPickupLocation from '../hero/hero-rslhome/CarPickupLocation'
import HotelDestinationCity from '../hero/hero-rslhome/car/ActivityDestinationCityCar'
import CarRentalTime from '../hero/hero-rslhome/CarRentalTime'
import HotelCalanderFrom from '../hero/hero-rslhome/CarRentalCalanderFrom'
import BookRideDatePicker from '../hero/hero-rslhome/BookRideDatePicker'
import BookRideDatePickerMobile from '../hero/hero-rslhome/BookRideDatePickerMobile'
import Skeleton from '@mui/material/Skeleton'
import CircularProgress from '@mui/material/CircularProgress'
import { axiosInstance } from '../../utils/axiosInstance';
// Date and Time
import DatePicker from 'react-multi-date-picker'
import TimePicker from 'react-multi-date-picker/plugins/time_picker'
import { useDispatch, useSelector } from '../../redux/store'
import { searchCar } from '../../redux/slices/product'
import CarDropLocation from '../hero/hero-rslhome/CarDropLocation'
import moment from 'moment'
import PickUpLocation from '../goole-location/pickupLocation'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import {
  GoogleMap,
  DirectionsService,
  DirectionsRenderer
} from '@react-google-maps/api'
import { Typography } from '@mui/material'

const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important'
        }
      }
    }
  }
})

const ActivitiesRSL = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const { carSearchRes } = useSelector(state => state.product)
  const [bookPickUp, setBookPickUp] = useState(null)
  const [country, setCountry] = useState(null)
  const [singleDate, setSingleDate] = useState(moment().format('YYYY-MM-DD'))
  const [checkInDate, setCheckInDate] = useState('')
  const [checkOutDate, setCheckOutDate] = useState('')
  const [cityValue, setCityValue] = useState([])
  const [timeValue, setTimeValue] = useState('')
  const [timeValue1, setTimeValue1] = useState(moment().format('HH:mm:ss'))
  const [cityDropValue, setCityDropValue] = useState('')
  const [bookDropOff, setBookDropOff] = useState(null)
  const [stateCountry, setStateCountry] = useState('')
  const [loader, setLoader] = useState(false)
  const [loaderSearch, setLoaderSearch] = useState(false)
  const [searchProduct, setSearchProduct] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [isButtonDisabled1, setIsButtonDisabled1] = useState(true)
  const [pickup, setPickup] = useState('')
  const [drop, setDrop] = useState('')
  const [pickupLatlng, setPickupLatlng] = useState({
    lat: '',
    lng: ''
  })
  const [dropLatlng, setDropLatlng] = useState({
    lat: '',
    lng: ''
  })

  const [distance, setDistance] = useState('')
  const [duration, setDuration] = useState('')
  const [pickupDateTime, setPickupDateTime] = useState('')
  const [dropDateTime, setdropDateTime] = useState('')
  const [bookRide, setBookRide] = useState(true)
  const [carRentals, setCarRentals] = useState(false)
  const [btnStatus, setBtnStatus] = useState(true)

  const [loading, setLoading] = useState(true)

  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)

  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [isFormValid, setIsFormValid] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current.querySelector('input').focus()
    }
  }, [])

  useEffect(() => {
    if (selectedValue?.name !== '' && selectedValue !== null) {
      if (autocompleteNext.current) {
        autocompleteNext.current.querySelector('input').focus()
        setFocusNext(true)
      }
    }
  }, [selectedValue])

  useEffect(() => {
    setIsSubmitClicked(false)
    if (
      checkInDate !== '' &&
      checkOutDate !== '' &&
      selectedValue?.name !== '' &&
      selectedValue !== null
    ) {
      setIsButtonDisabled(false)
    } else {
      setIsButtonDisabled(true)
    }
  }, [checkOutDate, checkInDate, selectedValue])

  useEffect(() => {
    setIsSubmitClicked(false)
    if (
      pickup &&
      pickup !== '' &&
      singleDate &&
      singleDate !== '' &&
      timeValue1 &&
      timeValue1 !== ''
    ) {
      setIsButtonDisabled1(false)
    } else {
      setIsButtonDisabled1(true)
    }
  }, [pickup, drop, singleDate, timeValue1])

  const handleBookPickUpChange = e => {
    setBookPickUp(e.target.value)
  }

  const handleCountryChange = e => {
    setCountry(e.target.value)
  }

  const handleBookDropOffChange = selectedDropOffBook => {
    setBookDropOff(selectedDropOffBook)
  }

  useEffect(() => {
    setLoading(true)
    dispatch(
      searchCar({ query: searchProduct.length > 0 ? searchProduct : '' })
    )
  }, [searchProduct])

  const handleBooking = () => {
    setIsSubmitClicked(true)
    if (
      selectedValue?.name !== '' &&
      selectedValue !== null &&
      checkInDate !== '' &&
      timeValue !== ''
    ) {
      setLoader(true)
      router.push({
        pathname: '/carBooking/carRentals',
        query: {
          cityName: selectedValue?.cityName,
          name: selectedValue?.name,
          pickupDateTime: moment(checkInDate).format?.('YYYY-MM-DD'),
          pickupDateTimecheckOutDate:
            moment(checkOutDate).format?.('YYYY-MM-DD'),
          pickupTimeValue: timeValue,
          productId: selectedValue?._id
        }
      })
    } else {
      setIsFormValid(false)
      setErrorMessage('Please fill in all fields.')
    }
  }

  const handleBookingRide = () => {
    setIsSubmitClicked(true)
    if (pickup !== '' && pickup !== null && drop !== '') {
      setLoader(true)
      router.push({
        pathname: '/carBooking/carBookRide',
        query: {
          pick_up: pickup,
          drop_off: drop,
          pickup_Latlng: JSON.stringify(pickupLatlng),
          drop_Latlng: JSON.stringify(dropLatlng),
          date: singleDate,
          time: timeValue1,
          pickupTimeValue: timeValue,
          distance_main: distance
        }
      })
    } else {
      setIsFormValid(false)
      setErrorMessage('Please fill in all fields.')
    }
  }

  const handlePickupDateTime = newValue => {
    setPickupDateTime(newValue?.format?.('YYYY-MM-DD'))
  }

  const handleDropDateTime = newValue => {
    setdropDateTime(newValue?.format?.('YYYY-MM-DD HH:mm:ss'))
  }

  const [isDropLocationChecked, setIsDropLocationChecked] = useState(false)

  const handleCheckboxChange = event => {
    setIsDropLocationChecked(event.target.checked)
  }

  const handleBookride = () => {
    setBookRide(true)
    setCarRentals(false)
  }
  const handleCarRentals = () => {
    setCarRentals(true)
    setBookRide(false)
  }

  useEffect(() => {
    // if (carSearchRes.length > 0) {
    if (carSearchRes !== undefined) {
      // Create an empty object
      const myObjectDestination = {}
      const childArrayDestination = []
      // const myObjectCarList = {};
      // const childArrayCarList = [];
      const mainArray = []
      if (carSearchRes?.destination !== undefined) {
        if (carSearchRes?.destination.length > 0) {
          carSearchRes?.destination.map(data => {
            myObjectDestination.label = 'Destination'
            myObjectDestination.img = '/img/general/flag.png'
            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
          })
        } else {
          myObjectDestination.label = 'Destination'
          myObjectDestination.values = []
        }
      }

      setLoading(false)
      mainArray.push(myObjectDestination)
      setCityValue(mainArray)
    }
  }, [carSearchRes])

  useEffect(() => {
    if (pickup && pickup !== '') {
      componentDidMountPickup()
    }
  }, [pickup])

  useEffect(() => {
    if (drop && drop !== '') {
      componentDidMountDrop()
    }
  }, [drop])

  useEffect(() => {
    if (pickup && drop && pickup !== '' && drop !== '') {
      //   // getRouteDistanceAndDuration(pickup,drop);
      calculateDistanceAndDuration(pickup, drop)
    }
  }, [pickup, drop])

  const calculateDistanceAndDuration = (origin, destination) => {
    const directionsService = new window.google.maps.DirectionsService()

    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: window.google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          // setDirections(result);
          setDuration(result.routes[0].legs[0].duration.text)
          setDistance(result.routes[0].legs[0].distance.text)
        } else {
        }
      }
    )
  }

  // console.log('pickupLatlng=========>', pickupLatlng)
  // console.log('dropLatlng=========>', dropLatlng)

  const componentDidMountPickup = async () => {
    const response = await axiosInstance.get(
      `${process.env.BACKEND_URL}/location/geocode?address=${pickup}`
    )
    // const response = await axios.get(`/api/geocode?address=${pickup}`)

    const { results } = response.data;

    if (results && results.length > 0) {
      const { lat, lng } = results[0].geometry.location
      setPickupLatlng({
        ...pickupLatlng,
        ['lat']: lat ? lat : 0,
        ['lng']: lng ? lng : 0
      })
    } else {
      setPickupLatlng({
        lat: '',
        lng: ''
      })
    }
  }

  const componentDidMountDrop = async () => {
    const response = await axiosInstance.get(
      `${process.env.BACKEND_URL}/location/geocode?address=${drop}`
    )
    // const response = await axios.get(`/api/geocode?address=${drop}`)

    const { results } = response.data
    if (results && results.length > 0) {
      const { lat, lng } = results[0].geometry.location
      setDropLatlng({
        ...dropLatlng,
        ['lat']: lat ? lat : 0,
        ['lng']: lng ? lng : 0
      })
    } else {
      setDropLatlng({
        lat: '',
        lng: ''
      })
      return null
    }
  }

  return (
    <>
      {bookRide && (
        <div className='activites_rsl y-gap-40'>
          <div className='activites_input'>
            <div className='d-flex align-start gap-10 pb-20'>
              <h4 className='text-15 fw-500 ls-2 lh-16 mb-10 text-black'>
                Book your car and enjoy your ride
              </h4>
            </div>
            <div className='CarBooking pb-20'>
              <PickUpLocation
                type={'pickup'}
                pickup={pickup}
                size='small'
                label='Pickup Location'
                placeholder='Search'
                setLoading={setLoading}
                loading={loading}
                autocompleteFirst={autocompleteFirst}
                setPickup={mPickUp => {
                  setPickup(mPickUp)
                }}
                setDrop={mDrop => {
                  setDrop(mDrop)
                }}
                error={
                  (isSubmitClicked && pickup === '') || pickup === null
                    ? true
                    : false
                }
                helperText={
                  (isSubmitClicked && pickup === '') || pickup === null
                    ? 'Pickup Location Required'
                    : ''
                }
              />

              <PickUpLocation
                type={'drop'}
                size='small'
                drop={drop}
                setPickup={mPickUp => {
                  setPickup(mPickUp)
                }}
                label='Drop Location'
                placeholder='Search'
                setLoading={setLoading}
                loading={loading}
                focusNext={focusNext}
                setDrop={mDrop => {
                  setDrop(mDrop)
                }}
                error={isSubmitClicked && drop === '' ? true : false}
                helperText={
                  isSubmitClicked && drop === '' ? 'Drop Location Required' : ''
                }
              />

              <div className='d-none d-sm-none d-md-flex'>
                <BookRideDatePicker
                  setSingleDate={setSingleDate}
                  singleDate={singleDate}
                  setTimeValue={setTimeValue1}
                  timeValue={timeValue1}
                />
              </div>
              <div className='d-md-none'>
                <BookRideDatePickerMobile
                  setSingleDate={setSingleDate}
                  singleDate={singleDate}
                  setTimeValue={setTimeValue1}
                  timeValue={timeValue1}
                />
              </div>

              <ThemeProvider theme={customTheme}>
                <button
                  className='mainSearch__submit btn-1 button -dark-4 py-10 px-15  bg-dark-3 text-white w-100'
                  onClick={handleBookingRide}
                >
                  {loader ? <CircularProgress /> : 'Book'}
                </button>
              </ThemeProvider>
            </div>
            {/* <div className="booking-btns">
              <div className="px-0 d-flex">

              </div>
              <div className="trip-booking__btn">
                <ThemeProvider theme={customTheme}>

                  <button
                    className="mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white w-75"
                    onClick={handleBookingRide}
                  >
                    {loader ? <CircularProgress /> : "Book Now"}
                  </button>
                </ThemeProvider>
              </div>
            </div> */}
          </div>
        </div>
      )}

      {carRentals && (
        <>
          <div className='activites_rsl y-gap-40'>
            <div className='activites_input mt-20'>
              <div className='d-flex align-start gap-10'>
                <h4 className='text-15 fw-500 ls-2 lh-16 mb-20 text-black'>
                  Book your car and enjoy your ride
                </h4>
                <Typography
                  style={{ color: 'red', marginTop: '2px', fontSize: '12px' }}
                >
                  * Mandatory fields
                </Typography>
              </div>

              <div
                className={`${isDropLocationChecked
                  ? 'carbooking-dropLocation'
                  : 'CarBooking'
                  }`}
              >
                {/* <CarPickupLocation
                setCityValue={setCityValue}
                cityValue={cityValue}
              /> */}

                <HotelDestinationCity
                  setCityValue={setCityValue}
                  cityValue={cityValue}
                  searchProduct={searchProduct}
                  setSearchProduct={setSearchProduct}
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  // label="Select your City? *"
                  label='Select your City? *'
                  placeholder='Search'
                  setLoading={setLoading}
                  loading={loading}
                  autocompleteFirst={autocompleteFirst}
                  error={
                    isSubmitClicked && selectedValue === null ? true : false
                  }
                  helperText={
                    isSubmitClicked && selectedValue === null ? 'Required' : ''
                  }
                />

                {isDropLocationChecked ? (
                  <CarDropLocation
                    setCityDropValue={setCityDropValue}
                    cityDropValue={cityDropValue}
                  />
                ) : (
                  ''
                )}

                <div className='d-flex'>
                  <HotelCalanderFrom
                    setCheckInDate={setCheckInDate}
                    setCheckOutDate={setCheckOutDate}
                    checkInDate={checkInDate}
                    checkOutDate={checkOutDate}
                    error={isSubmitClicked && checkInDate === '' ? true : false}
                    helperText={
                      isSubmitClicked && checkInDate === '' ? 'Required' : ''
                    }
                  />
                </div>

                <div className='d-flex align-center'>
                  <CarRentalTime
                    setTimeValue={setTimeValue}
                    timeValue={timeValue}
                    error={isSubmitClicked && timeValue === '' ? true : false}
                    helperText={
                      isSubmitClicked && timeValue === '' ? 'Required' : ''
                    }
                  />
                </div>
              </div>

              <div className='booking-btns py-40'>
                <div className='px-0 d-flex'></div>
                <div className='trip-booking__btn'>
                  <ThemeProvider theme={customTheme}>
                    <button
                      className='mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white w-75'
                      onClick={handleBooking}
                    >
                      {loader ? <CircularProgress /> : 'Book Now'}
                    </button>
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ActivitiesRSL
